import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderSlot as _renderSlot, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-07f3b001")

_pushScopeId("data-v-07f3b001")
const _hoisted_1 = { class: "full-width d-flex justify-content-between align-items-center mb-2" }
const _hoisted_2 = { class: "subtitle font-size-15 fw-normal m-0" }
const _hoisted_3 = { class: "d-flex flex-row flex-wrap items small" }
_popScopeId()


    
export default _defineComponent({
  props: {
        label: String
    },
  setup(__props) {

const props = __props
    /* eslint-disable no-unused-vars */
    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock("div", null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("div", _hoisted_2, _toDisplayString(__props.label), 1),
      _createVNode("button", {
        type: "button",
        class: "ui-link manage-ui-link font-size-12",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('manageClicked')))
      }, "Manage")
    ]),
    _createVNode("div", _hoisted_3, [
      _renderSlot(_ctx.$slots, "default")
    ])
  ]))
}
}

})